import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import { useSelector } from 'react-redux';

const Permission = ({
    setHasPermission,
    setCanEdit,
    hasPermission,
    pagePermission,
    showDenied = false
}) => {

    const { permissions } = useSelector(state => ({
        permissions: state.authentication.permissions
    }));
    const [permissionCheckComplete, setPermissionCheckComplete] = useState(false);

    useEffect(() => {   
        if(!_.isEmpty(permissions)){
            permissions.filter((perm) => {
                if(perm.name === pagePermission){
                    setHasPermission(true);

                    if(perm.edit === true || perm.edit === 'true'){
                        setCanEdit(true);
                    }
                } 
                
            });
        }
        setPermissionCheckComplete(true);
    }, [pagePermission]);

    const styles = {
        display: 'flex',
        justifyContent: 'center',
        marginBottom: '3em',
        marginTop: '3em',
        border: 0,
    };

    return (
        <>
            {permissionCheckComplete && !hasPermission && showDenied && 
                <div style={{ ...styles }}>
                    <div>
                        <h3>Access Denied</h3>
                    </div>
                </div>
            }
        </>
        
    );
};

export default Permission;